import React from 'react';

const PatientDetails = ({ patient }) => (
  <div className="patient-details">
    <p><strong>Name:</strong> {patient.firstName} {patient.lastName}</p>
    <p><strong>Phone:</strong> {patient.phone}</p>
    <p><strong>Email:</strong> {patient.email}</p>
    <p><strong>Sex:</strong> {patient.sex}</p>
    <p><strong>DOB:</strong> {patient.dob}</p>
  </div>
);

export default PatientDetails;